import React, { useEffect } from 'react';

const GoogleTranslate = () => {
  useEffect(() => {
    // Load Google Translate script dynamically
    const script = document.createElement("script");
    script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);

    // Initialize the Google Translate element after the script is loaded
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",  // Default language of your website
          includedLanguages: "de,nl,fr,tr,et,fi,sv,el,hi,en,ga,it,lv,lt,lb,mt,pt,sk,sl,es,sq,sr,ca,la",  // Specify the languages from the selected countries
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,  // Set to false to prevent automatic display
        },
        "google_translate_element"
      );
    };

    return () => {
      // Cleanup the script when the component is unmounted
      document.body.removeChild(script);
    };
  }, []);

  return <div id="google_translate_element"></div>;
};

export default GoogleTranslate;
